import {ActionType} from 'typesafe-actions';
import * as actions from './actions';
import * as sharedActions from '../shared/actions';
import {FunctionalLocationSelection} from '../analytics';
import {FileType, RequestStatus} from '../shared/types';
import {ReportType} from '../../pages/reports/report-catalog';
import {FunctionalLocationsSelectionsControlValue} from '../../pages/analytics/dashboard-controls/functional-locations-selector/types/functional-locations-selections-control-value';

export enum ReportsActionTypes {
    FETCH_ENHANCED_ACTIVE_FLEET_REPORT_REQUEST = '@@reports/FETCH_ENHANCED_ACTIVE_FLEET_REPORT_REQUEST',
    FETCH_ENHANCED_ACTIVE_FLEET_REPORT_SUCCESS = '@@reports/FETCH_ENHANCED_ACTIVE_FLEET_REPORT_SUCCESS',
    FETCH_ENHANCED_ACTIVE_FLEET_REPORT_FAILURE = '@@reports/FETCH_ENHANCED_ACTIVE_FLEET_REPORT_FAILURE',
    FETCH_MASTER_FLEET_LIST_REPORT_REQUEST = '@@reports/FETCH_MASTER_FLEET_LIST_REPORT_REQUEST',
    FETCH_MASTER_FLEET_LIST_REPORT_SUCCESS = '@@reports/FETCH_MASTER_FLEET_LIST_REPORT_SUCCESS',
    FETCH_MASTER_FLEET_LIST_REPORT_FAILURE = '@@reports/FETCH_MASTER_FLEET_LIST_REPORT_FAILURE',
    FETCH_VEHICLE_JOB_LIST_REPORT_REQUEST = '@@reports/FETCH_VEHICLE_JOB_LIST_REPORT_REQUEST',
    FETCH_VEHICLE_JOB_LIST_REPORT_SUCCESS = '@@reports/FETCH_VEHICLE_JOB_LIST_REPORT_SUCCESS',
    FETCH_VEHICLE_JOB_LIST_REPORT_FAILURE = '@@reports/FETCH_VEHICLE_JOB_LIST_REPORT_FAILURE',
    FETCH_UNBILLED_JOBS_REPORT_REQUEST = '@@reports/FETCH_UNBILLED_JOBS_REPORT_REQUEST',
    FETCH_UNBILLED_JOBS_REPORT_SUCCESS = '@@reports/FETCH_UNBILLED_JOBS_REPORT_SUCCESS',
    FETCH_UNBILLED_JOBS_REPORT_FAILURE = '@@reports/FETCH_UNBILLED_JOBS_REPORT_FAILURE',
    FETCH_MOUNTED_TIRE_DETAILS_REPORT_REQUEST = '@@reports/FETCH_MOUNTED_TIRE_DETAILS_REPORT_REQUEST',
    FETCH_MOUNTED_TIRE_DETAILS_REPORT_SUCCESS = '@@reports/FETCH_MOUNTED_TIRE_DETAILS_REPORT_SUCCESS',
    FETCH_MOUNTED_TIRE_DETAILS_REPORT_FAILURE = '@@reports/FETCH_MOUNTED_TIRE_DETAILS_REPORT_FAILURE',
    FETCH_DAMAGED_TIRE_DETAILS_REPORT_REQUEST = '@@reports/FETCH_DAMAGED_TIRE_DETAILS_REPORT_REQUEST',
    FETCH_DAMAGED_TIRE_DETAILS_REPORT_SUCCESS = '@@reports/FETCH_DAMAGED_TIRE_DETAILS_REPORT_SUCCESS',
    FETCH_DAMAGED_TIRE_DETAILS_REPORT_FAILURE = '@@reports/FETCH_DAMAGED_TIRE_DETAILS_REPORT_FAILURE',
    FETCH_EXTENDED_INSPECTION_REPORT_REQUEST = '@@reports/FETCH_EXTENDED_INSPECTION_REPORT_REQUEST',
    FETCH_EXTENDED_INSPECTION_REPORT_SUCCESS = '@@reports/FETCH_EXTENDED_INSPECTION_REPORT_SUCCESS',
    FETCH_EXTENDED_INSPECTION_REPORT_FAILURE = '@@reports/FETCH_EXTENDED_INSPECTION_REPORT_FAILURE',
    FETCH_EXTENDED_SERVICE_REPORT_REQUEST = '@@reports/FETCH_EXTENDED_SERVICE_REPORT_REQUEST',
    FETCH_EXTENDED_SERVICE_REPORT_SUCCESS = '@@reports/FETCH_EXTENDED_SERVICE_REPORT_SUCCESS',
    FETCH_EXTENDED_SERVICE_REPORT_FAILURE = '@@reports/FETCH_EXTENDED_SERVICE_REPORT_FAILURE',
    FETCH_VEHICLES_DUE_FOR_INSPECTION_REPORT_REQUEST = '@@reports/FETCH_VEHICLES_DUE_FOR_INSPECTION_REPORT_REQUEST',
    FETCH_VEHICLES_DUE_FOR_INSPECTION_REPORT_SUCCESS = '@@reports/FETCH_VEHICLES_DUE_FOR_INSPECTION_REPORT_SUCCESS',
    FETCH_VEHICLES_DUE_FOR_INSPECTION_REPORT_FAILURE = '@@reports/FETCH_VEHICLES_DUE_FOR_INSPECTION_REPORT_FAILURE',
    FETCH_REMOVED_AND_FITTED_TIRES_REPORT_REQUEST = '@@reports/FETCH_REMOVED_AND_FITTED_TIRES_REPORT_REQUEST',
    FETCH_REMOVED_AND_FITTED_TIRES_REPORT_SUCCESS = '@@reports/FETCH_REMOVED_AND_FITTED_TIRES_REPORT_SUCCESS',
    FETCH_REMOVED_AND_FITTED_TIRES_REPORT_FAILURE = '@@reports/FETCH_REMOVED_AND_FITTED_TIRES_REPORT_FAILURE',
    FETCH_MILEAGE_BILLING_REPORT_REQUEST = '@@reports/FETCH_MILEAGE_BILLING_REPORT_REQUEST',
    FETCH_MILEAGE_BILLING_REPORT_SUCCESS = '@@reports/FETCH_MILEAGE_BILLING_REPORT_SUCCESS',
    FETCH_MILEAGE_BILLING_REPORT_FAILURE = '@@reports/FETCH_MILEAGE_BILLING_REPORT_FAILURE',
    FETCH_BREAKDOWN_AND_SERVICES_BILLING_REPORT_REQUEST = '@@reports/FETCH_BREAKDOWN_AND_SERVICES_BILLING_REPORT_REQUEST',
    FETCH_BREAKDOWN_AND_SERVICES_BILLING_REPORT_SUCCESS = '@@reports/FETCH_BREAKDOWN_AND_SERVICES_BILLING_REPORT_SUCCESS',
    FETCH_BREAKDOWN_AND_SERVICES_BILLING_REPORT_FAILURE = '@@reports/FETCH_BREAKDOWN_AND_SERVICES_BILLING_REPORT_FAILURE',
    FETCH_DAMAGED_TIRES_BILLING_REPORT_REQUEST = '@@reports/FETCH_DAMAGED_TIRES_BILLING_REPORT_REQUEST',
    FETCH_DAMAGED_TIRES_BILLING_REPORT_SUCCESS = '@@reports/FETCH_DAMAGED_TIRES_BILLING_REPORT_SUCCESS',
    FETCH_DAMAGED_TIRES_BILLING_REPORT_FAILURE = '@@reports/FETCH_DAMAGED_TIRES_BILLING_REPORT_FAILURE',
    FETCH_UNMOUNTED_TIRES_REPORT_REQUEST = '@@reports/FETCH_UNMOUNTED_TIRES_REPORT_REQUEST',
    FETCH_UNMOUNTED_TIRES_REPORT_SUCCESS = '@@reports/FETCH_UNMOUNTED_TIRES_REPORT_SUCCESS',
    FETCH_UNMOUNTED_TIRES_REPORT_FAILURE = '@@reports/FETCH_UNMOUNTED_TIRES_REPORT_FAILURE',
    FETCH_TIRE_STOCK_COMPANIES_REQUEST = '@@reports/FETCH_TIRE_STOCK_COMPANIES_REQUEST',
    FETCH_TIRE_STOCK_COMPANIES_SUCCESS = '@@reports/FETCH_TIRE_STOCK_COMPANIES_SUCCESS',
    FETCH_TIRE_STOCK_COMPANIES_FAILURE = '@@reports/FETCH_TIRE_STOCK_COMPANIES_FAILURE',
    FETCH_TIRE_STOCK_REPORT_REQUEST = '@@reports/FETCH_TIRE_STOCK_REPORT_REQUEST',
    FETCH_TIRE_STOCK_REPORT_SUCCESS = '@@reports/FETCH_TIRE_STOCK_REPORT_SUCCESS',
    FETCH_TIRE_STOCK_REPORT_FAILURE = '@@reports/FETCH_TIRE_STOCK_REPORT_FAILURE',
    FETCH_TIRE_PERFORMANCE_OPTIONS_REQUEST = '@@reports/FETCH_TIRE_PERFORMANCE_OPTIONS_REQUEST',
    FETCH_TIRE_PERFORMANCE_OPTIONS_SUCCESS = '@@reports/FETCH_TIRE_PERFORMANCE_OPTIONS_SUCCESS',
    FETCH_TIRE_PERFORMANCE_OPTIONS_FAILURE = '@@reports/FETCH_TIRE_PERFORMANCE_OPTIONS_FAILURE',
    FETCH_TIRE_PERFORMANCE_REPORT_REQUEST = '@@reports/FETCH_TIRE_PERFORMANCE_REPORT_REQUEST',
    FETCH_TIRE_PERFORMANCE_REPORT_SUCCESS = '@@reports/FETCH_TIRE_PERFORMANCE_REPORT_SUCCESS',
    FETCH_TIRE_PERFORMANCE_REPORT_FAILURE = '@@reports/FETCH_TIRE_PERFORMANCE_REPORT_FAILURE',
    FETCH_TIRE_HISTORY_REPORT_REQUEST = '@@reports/FETCH_TIRE_HISTORY_REPORT_REQUEST',
    FETCH_TIRE_HISTORY_REPORT_SUCCESS = '@@reports/FETCH_TIRE_HISTORY_REPORT_SUCCESS',
    FETCH_TIRE_HISTORY_REPORT_FAILURE = '@@reports/FETCH_TIRE_HISTORY_REPORT_FAILURE',
    FETCH_VEHICLES_CURRENT_STATUS_REPORT_REQUEST = '@@reports/FETCH_VEHICLES_CURRENT_STATUS_REPORT_REQUEST',
    FETCH_VEHICLES_CURRENT_STATUS_REPORT_SUCCESS = '@@reports/FETCH_VEHICLES_CURRENT_STATUS_REPORT_SUCCESS',
    FETCH_VEHICLES_CURRENT_STATUS_REPORT_FAILURE = '@@reports/FETCH_VEHICLES_CURRENT_STATUS_REPORT_FAILURE',
    FETCH_INVOICE_BY_JOB_REPORT_REQUEST = '@@reports/FETCH_INVOICE_BY_JOB_REPORT_REQUEST',
    FETCH_INVOICE_BY_JOB_REPORT_SUCCESS = '@@reports/FETCH_INVOICE_BY_JOB_REPORT_SUCCESS',
    FETCH_INVOICE_BY_JOB_REPORT_FAILURE = '@@reports/FETCH_INVOICE_BY_JOB_REPORT_FAILURE',
    FETCH_INVOICE_BY_VEHICLE_REPORT_REQUEST = '@@reports/FETCH_INVOICE_BY_VEHICLE_REPORT_REQUEST',
    FETCH_INVOICE_BY_VEHICLE_REPORT_SUCCESS = '@@reports/FETCH_INVOICE_BY_VEHICLE_REPORT_SUCCESS',
    FETCH_INVOICE_BY_VEHICLE_REPORT_FAILURE = '@@reports/FETCH_INVOICE_BY_VEHICLE_REPORT_FAILURE',
    FETCH_INVOICE_ITEM_BY_VEHICLE_REPORT_REQUEST = '@@reports/FETCH_INVOICE_ITEM_BY_VEHICLE_REPORT_REQUEST',
    FETCH_INVOICE_ITEM_BY_VEHICLE_REPORT_SUCCESS = '@@reports/FETCH_INVOICE_ITEM_BY_VEHICLE_REPORT_SUCCESS',
    FETCH_INVOICE_ITEM_BY_VEHICLE_REPORT_FAILURE = '@@reports/FETCH_INVOICE_ITEM_BY_VEHICLE_REPORT_FAILURE',
    FETCH_ENHANCED_INVOICE_ITEM_BY_VEHICLE_REPORT_REQUEST = '@@reports/FETCH_ENHANCED_INVOICE_ITEM_BY_VEHICLE_REPORT_REQUEST',
    FETCH_ENHANCED_INVOICE_ITEM_BY_VEHICLE_REPORT_SUCCESS = '@@reports/FETCH_ENHANCED_INVOICE_ITEM_BY_VEHICLE_REPORT_SUCCESS',
    FETCH_ENHANCED_INVOICE_ITEM_BY_VEHICLE_REPORT_FAILURE = '@@reports/FETCH_ENHANCED_INVOICE_ITEM_BY_VEHICLE_REPORT_FAILURE',
    FETCH_INSPECTION_DETAILS_REPORT_REQUEST = '@@reports/FETCH_INSPECTION_DETAILS_REPORT_REQUEST',
    FETCH_INSPECTION_DETAILS_REPORT_SUCCESS = '@@reports/FETCH_INSPECTION_DETAILS_REPORT_SUCCESS',
    FETCH_INSPECTION_DETAILS_REPORT_FAILURE = '@@reports/FETCH_INSPECTION_DETAILS_REPORT_FAILURE',
    FETCH_TCU_SENSOR_FITMENTS_REPORT_REQUEST = '@@reports/FETCH_TCU_SENSOR_FITMENTS_REPORT_REQUEST',
    FETCH_TCU_SENSOR_FITMENTS_REPORT_SUCCESS = '@@reports/FETCH_TCU_SENSOR_FITMENTS_REPORT_SUCCESS',
    FETCH_TCU_SENSOR_FITMENTS_REPORT_FAILURE = '@@reports/FETCH_TCU_SENSOR_FITMENTS_REPORT_FAILURE',
    FETCH_BREAKDOWN_LIST_REPORT_REQUEST = '@@reports/FETCH_BREAKDOWN_LIST_REPORT_REQUEST',
    FETCH_BREAKDOWN_LIST_REPORT_SUCCESS = '@@reports/FETCH_BREAKDOWN_LIST_REPORT_SUCCESS',
    FETCH_BREAKDOWN_LIST_REPORT_FAILURE = '@@reports/FETCH_BREAKDOWN_LIST_REPORT_FAILURE',
    FETCH_JOB_VERIFICATION_REPORT_REQUEST = '@@reports/FETCH_JOB_VERIFICATION_REPORT_REQUEST',
    FETCH_JOB_VERIFICATION_REPORT_SUCCESS = '@@reports/FETCH_JOB_VERIFICATION_REPORT_SUCCESS',
    FETCH_JOB_VERIFICATION_REPORT_FAILURE = '@@reports/FETCH_JOB_VERIFICATION_REPORT_FAILURE',
    FETCH_ODOMETER_LIST_REPORT_REQUEST = '@@reports/FETCH_ODOMETER_LIST_REPORT_REQUEST',
    FETCH_ODOMETER_LIST_REPORT_SUCCESS = '@@reports/FETCH_ODOMETER_LIST_REPORT_SUCCESS',
    FETCH_ODOMETER_LIST_REPORT_FAILURE = '@@reports/FETCH_ODOMETER_LIST_REPORT_FAILURE',

    FETCH_SCHEDULED_REPORTS_REQUEST = '@@reports/FETCH_SCHEDULED_REPORTS_REQUEST',
    FETCH_SCHEDULED_REPORTS_SUCCESS = '@@reports/FETCH_SCHEDULED_REPORTS_SUCCESS',
    FETCH_SCHEDULED_REPORTS_FAILURE = '@@reports/FETCH_SCHEDULED_REPORTS_FAILURE',
    CREATE_SCHEDULED_REPORT_REQUEST = '@@reports/CREATE_SCHEDULED_REPORT_REQUEST',
    CREATE_SCHEDULED_REPORT_SUCCESS = '@@reports/CREATE_SCHEDULED_REPORT_SUCCESS',
    CREATE_SCHEDULED_REPORT_FAILURE = '@@reports/CREATE_SCHEDULED_REPORT_FAILURE',
    UPDATE_SCHEDULED_REPORT_REQUEST = '@@reports/UPDATE_SCHEDULED_REPORT_REQUEST',
    UPDATE_SCHEDULED_REPORT_SUCCESS = '@@reports/UPDATE_SCHEDULED_REPORT_SUCCESS',
    UPDATE_SCHEDULED_REPORT_FAILURE = '@@reports/UPDATE_SCHEDULED_REPORT_FAILURE',
    DELETE_SCHEDULED_REPORT_REQUEST = '@@reports/DELETE_SCHEDULED_REPORT_REQUEST',
    DELETE_SCHEDULED_REPORT_SUCCESS = '@@reports/DELETE_SCHEDULED_REPORT_SUCCESS',
    DELETE_SCHEDULED_REPORT_FAILURE = '@@reports/DELETE_SCHEDULED_REPORT_FAILURE',

    FETCH_REPORT_INFO_REQUEST = '@@reports/FETCH_REPORT_INFO_REQUEST',
    FETCH_REPORT_INFO_SUCCESS = '@@reports/FETCH_REPORT_INFO_SUCCESS',
    FETCH_REPORT_INFO_FAILURE = '@@reports/FETCH_REPORT_INFO_FAILURE',

    FETCH_REPORT_DOWNLOAD_REQUEST = '@@reports/FETCH_REPORT_DOWNLOAD_REQUEST',
    FETCH_REPORT_DOWNLOAD_SUCCESS = '@@reports/FETCH_REPORT_DOWNLOAD_SUCCESS',
    FETCH_REPORT_DOWNLOAD_FAILURE = '@@reports/FETCH_REPORT_DOWNLOAD_FAILURE',
}

export type ReportsAction = ActionType<typeof actions> | ActionType<typeof sharedActions>;

export interface ReportsState {
    enhancedActiveFleetReportRequestStatus?: RequestStatus;
    masterFleetListReportRequestStatus?: RequestStatus;
    vehicleJobListReportRequestStatus?: RequestStatus;
    mountedTireDetailsReportRequestStatus?: RequestStatus;
    damagedTireDetailsReportRequestStatus?: RequestStatus;
    extendedInspectionReportRequestStatus?: RequestStatus;
    extendedServiceReportRequestStatus?: RequestStatus;
    vehiclesDueForInspectionReportRequestStatus?: RequestStatus;
    removedAndFittedTiresReportRequestStatus?: RequestStatus;
    mileageBillingReportRequestStatus?: RequestStatus;
    breakdownAndServicesBillingReportRequestStatus?: RequestStatus;
    damagedTiresBillingReportRequestStatus?: RequestStatus;
    unmountedTiresReportRequestStatus?: RequestStatus;
    tireStockReportRequestStatus?: RequestStatus;
    tireHistoryReportRequestStatus?: RequestStatus;
    tireStockCompaniesRequestStatus?: RequestStatus;
    tirePerformanceOptionsRequestStatus?: RequestStatus;
    vehiclesCurrentStatusRequestStatus?: RequestStatus;
    invoiceByJobRequestStatus?: RequestStatus;
    invoiceByVehicleRequestStatus?: RequestStatus;
    invoiceItemByVehicleRequestStatus?: RequestStatus;
    enhancedInvoiceItemByVehicleRequestStatus?: RequestStatus;
    unbilledJobsRequestStatus?: RequestStatus;
    breakdownListRequestStatus?: RequestStatus;
    inspectionDetailsRequestStatus?: RequestStatus;
    tcuSensorFitmentsRequestStatus?: RequestStatus;
    tirePerformanceRequestStatus?: RequestStatus;
    jobVerificationRequestStatus?: RequestStatus;
    odometerListRequestStatus?: RequestStatus;

    tirePerformanceOptions?: TirePerformanceOptions;
    tireStockCompanies?: TireStockCompany[];

    scheduledReports: ScheduledReport[];
    getScheduledReportsRequestStatus?: RequestStatus;
    createScheduledReportRequestStatus?: RequestStatus;
    updateScheduledReportRequestStatus?: RequestStatus;
    deleteScheduledReportRequestStatus?: RequestStatus;

    reportInfo?: ReportInfo;
    reportInfoRequestStatus?: RequestStatus;
    reportDownloadRequestStatus?: RequestStatus;
}

export enum SortColumn {
    byLicensePlate = 'licensePlate',
    byChassisNumber = 'chassisNumber',
    byFleetNumber = 'fleetNumber',
}

export enum ActiveStatus {
    All = 'all',
    Activated = 'activated',
    Deactivated = 'deactivated'
}

export enum InspectionStatus {
    All = 'all',
    NotSeenLastThreeMonths = 'notSeenLastThreeMonths',
    NotSeenLastMonth = 'notSeenLastMonth'
}

export interface ReportRequest{
    fileType:FileType
}

export interface EnhancedActiveFleetReportRequest extends ReportRequest{
    locations: FunctionalLocationSelection[];
    activeStatus: ActiveStatus;
    sortColumn: string;
}

export interface MasterFleetListReportRequest extends ReportRequest{
    locations: FunctionalLocationSelection[];
    activeStatus: ActiveStatus;
    sortColumn: string;
}

export interface VehicleJobListReportRequest extends ReportRequest {
    locations: FunctionalLocationSelection[];
    fromDate: string;
    toDate: string;
    licensePlate?: string;
    fleetNumber?: string;
}

export interface UnbilledJobsReportRequest extends ReportRequest{
    locations: FunctionalLocationSelection[];
    fromDate: string;
    toDate: string;
    licensePlate?: string;
    fleetNumber?: string;
}

export interface DamagedTireDetailsReportRequest extends ReportRequest{
    locations: FunctionalLocationSelection[];
    fromDate: string;
    toDate: string;
    licensePlate?: string;
    fleetNumber?: string;
}

export interface MountedTireDetailsReportRequest extends ReportRequest{
    locations: FunctionalLocationSelection[];
    fromDate: string;
    toDate: string;
}

export interface ExtendedInspectionReportRequest extends ReportRequest{
    locations: FunctionalLocationSelection[];
    inspectionStatus: string;
}

export interface VehiclesDueForInspectionReportRequest extends ReportRequest{
    locations: FunctionalLocationSelection[];
}

export interface RemovedAndFittedTiresReportRequest extends ReportRequest{
    locations: FunctionalLocationSelection[];
    fromDate: string;
    toDate: string;
    mountDemountOnly: boolean;
}

export interface MileageBillingReportRequest extends ReportRequest{
    locations: FunctionalLocationSelection[];
    fromDate: string;
    toDate: string;
    mountDemountOnly: boolean;
}

export interface BreakdownAndServicesBillingReportRequest extends ReportRequest{
    locations: FunctionalLocationSelection[];
    fromDate: string;
    toDate: string;
}

export interface DamagedTiresBillingReportRequest extends ReportRequest{
    fromDate: string;
    toDate: string;
}

export interface UnmountedTiresReportRequest extends ReportRequest{
    locations: FunctionalLocationSelection[];
    fromDate: string;
    toDate: string;
}

export interface TireStockCompany {
    companyNr: string;
    companyName: string;
}

export interface TirePerformanceOptions {
    sizeOptions: TirePerformanceOption[];
    brandOptions: TirePerformanceOption[];
    designOptions: TirePerformanceOption[];
    vehicleTypeOptions: TirePerformanceOption[];
}

export interface TirePerformanceOption {
    id: string;
    name: string;
}

export interface TireStockReportRequest extends ReportRequest {
    companies: TireStockCompany[];
}

export interface TireHistoryReportRequest extends ReportRequest {
    serialNumber: string;
}

export interface TireStockCompaniesRequest {
}

export interface TirePerformanceOptionsRequest {
}

export interface VehiclesCurrentStatusReportRequest extends ReportRequest {
    locations: FunctionalLocationSelection[];
    treadDepth?: number;
}

export interface InvoiceByJobReportRequest extends ReportRequest {
    locations: FunctionalLocationSelection[];
    fromDate: string;
    toDate: string;
}

export interface InvoiceByVehicleReportRequest extends ReportRequest {
    locations: FunctionalLocationSelection[];
    fromDate: string;
    toDate: string;
}

export interface InvoiceItemByVehicleReportRequest extends ReportRequest {
    locations: FunctionalLocationSelection[];
    fromDate: string;
    toDate: string;
}

export interface EnhancedInvoiceItemByVehicleReportRequest extends ReportRequest {
    locations: FunctionalLocationSelection[];
    fromDate: string;
    toDate: string;
}

export interface TCUSensorFitmentsReportRequest extends ReportRequest {
    locations: FunctionalLocationSelection[];
    fromDate: string;
    toDate: string;
}

export interface InspectionDetailsReportRequest extends ReportRequest {
    locations: FunctionalLocationSelection[];
    fromDate: string;
    toDate: string;
}

export interface TirePerformanceReportRequest extends ReportRequest {
    locations: FunctionalLocationSelection[];
    fromDate: string;
    toDate: string;
    brand?: string | null;
    size?: string | null;
    design?: string | null;
    vehicleType?: string | null;
}

export interface BreakdownListReportRequest extends ReportRequest {
    locations: FunctionalLocationSelection[];
    fromDate: string;
    toDate: string;
}

export interface JobVerificationReportRequest extends ReportRequest {
    invoiceNumber?: string;
    jobNumber?: string;
}

export interface OdometerListReportRequest extends ReportRequest{
    locations: FunctionalLocationSelection[];
}

export enum ReportStatus {
    NEW = 'NEW',
    RUNNING = 'RUNNING',
    SUCCEEDED = 'SUCCEEDED',
    FAILED = 'FAILED',
}

export interface ReportInfo {
    id: string;
    fileName: string;
    type: ReportType;
    status: ReportStatus;
    requestedBy: string;
    requestedOn: string;
    startedOn?: string;
    generatedOn?: string;
    expiresOn?: string;
    deletedOn?: string;
}

export interface ReportDownloadUrl {
    url: string;
}

export enum ReportPeriodType {
    Custom,
    Scheduled
}

export enum ScheduledReportGranularity {
    WEEK = 'WEEK',
    MONTH = 'MONTH',
    YEAR = 'YEAR',
}

export enum ScheduledReportDeliveryMethod {
    EMAIL_ATTACHMENT = 'EMAIL_ATTACHMENT',
    DOWNLOAD_LINK = 'DOWNLOAD_LINK',
}

export interface ScheduledReport {
    id?: string;
    name: string;
    reportType: ReportType;
    parametersVersion: number;
    parameters: any;
    deliveryMethod: ScheduledReportDeliveryMethod;
    fileType:FileType;
    granularity: ScheduledReportGranularity;
    scheduleTime: string;
    recipients: string[];
}

export const SCHEDULED_REPORT_PARAMETER_VERSION = 1;

export enum ScheduledReportPeriod {
    PAST_WEEK = 'PAST_WEEK',
    PAST_MONTH = 'PAST_MONTH',
    PAST_YEAR = 'PAST_YEAR',
    MONTH_TO_DATE = 'MONTH_TO_DATE',
    YEAR_TO_DATE = 'YEAR_TO_DATE',
}

export interface ScheduledReportParameters {

}

export interface EnhancedActiveFleetScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    sortColumn: SortColumn;
    activeStatus: ActiveStatus;
}

export interface MasterFleetListScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    sortColumn: SortColumn;
    activeStatus: ActiveStatus;
}

export interface UnbilledJobsScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    period: ScheduledReportPeriod;
    licensePlate?: string;
    fleetNumber?: string;
}

export interface VehicleJobListScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    period: ScheduledReportPeriod;
    licensePlate?: string;
    fleetNumber?: string;
}

export interface MountedTireDetailsScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    period: ScheduledReportPeriod;
}

export interface DamagedTireDetailsScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    period: ScheduledReportPeriod;
    licensePlate?: string;
    fleetNumber?: string;
}

export interface ExtendedInspectionScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    inspectionStatus: InspectionStatus;
}

export interface ExtendedServiceScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    inspectionStatus: InspectionStatus;
}

export interface VehiclesDueForInspectionScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
}

export interface RemovedAndFittedTiresScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    period: ScheduledReportPeriod;
    mountDemountOnly: boolean;
}

export interface MileageBillingScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    period: ScheduledReportPeriod;
    mountDemountOnly: boolean;
}

export interface BreakdownAndServicesBillingScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    period: ScheduledReportPeriod;
}

export interface DamagedTiresBillingScheduledReportParameters extends ScheduledReportParameters {
    period: ScheduledReportPeriod;
}

export interface UnmountedTiresScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    period: ScheduledReportPeriod;
}

export interface TireStockScheduledReportParameters extends ScheduledReportParameters {
    companies: TireStockCompany[];
}

export interface TireHistoryScheduledReportParameters extends ScheduledReportParameters {
    serialNumber: string;
}

export interface VehiclesCurrentStatusScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    treadDepth?: number;
}

export interface InvoiceByJobScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    period: ScheduledReportPeriod;
}

export interface InvoiceByVehicleScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    period: ScheduledReportPeriod;
}

export interface InspectionDetailsScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    period: ScheduledReportPeriod;
}

export interface TCUSensorFitmentsScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    period: ScheduledReportPeriod;
}

export interface TirePerformanceScheduledReportParameters extends ScheduledReportParameters {
    brand?: string;
    size?: string;
    design?: string;
    vehicleType?: string;
    locations: FunctionalLocationSelection[];
    period: ScheduledReportPeriod;
}

export interface InvoiceItemByVehicleScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    period: ScheduledReportPeriod;
}

export interface EnhancedInvoiceItemByVehicleScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    period: ScheduledReportPeriod;
}

export interface BreakdownListScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
    period: ScheduledReportPeriod;
}

export interface JobVerificationScheduledReportParameters extends ScheduledReportParameters {
    invoiceNumber?: string;
    jobNumber?: string;
}

export interface OdometerListScheduledReportParameters extends ScheduledReportParameters {
    locations: FunctionalLocationSelection[];
}

export interface BreakdownListCustomReportParameters {
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface DamagedTireDetailsCustomReportParameters {
    licensePlate?: string;
    fleetNumber?: string;
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface EnhancedActiveFleetCustomReportParameters {
    selectedSortOrder?: SortColumn;
    selectedActiveStatus?: ActiveStatus;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface ExtendedInspectionCustomReportParameters {
    selectedInspectionStatus?: InspectionStatus;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface ExtendedServiceCustomReportParameters {
    selectedInspectionStatus?: InspectionStatus;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface TirePerformanceCustomReportParameters {
    brand?: string;
    size?: string;
    design?: string;
    vehicleType?: string;
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface InspectionDetailsCustomReportParameters {
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface TCUSensorFitmentsCustomReportParameters {
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface InvoiceByJobCustomReportParameters {
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface InvoiceByVehicleCustomReportParameters {
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface InvoiceItemByVehicleCustomReportParameters {
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface EnhancedInvoiceItemByVehicleCustomReportParameters {
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface MasterFleetListCustomReportParameters {
    selectedSortOrder?: SortColumn;
    selectedActiveStatus?: ActiveStatus;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface MountedTireDetailsCustomReportParameters {
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface RemovedAndFittedTiresCustomReportParameters {
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
    mountDemountOnly: boolean;
}

export interface MileageBillingCustomReportParameters {
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
    mountDemountOnly: boolean;
}

export interface BreakdownAndServicesBillingCustomReportParameters {
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface DamagedTiresBillingCustomReportParameters {
    fromDate?: Date;
    toDate?: Date;
}

export interface TireHistoryCustomReportParameters {
    serialNumber?: string;
}

export interface TireStockCustomReportParameters {
    companies: TireStockCompany[];
}

export interface UnmountedTiresCustomReportParameters {
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface VehicleJobListCustomReportParameters {
    licensePlate?: string;
    fleetNumber?: string;
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface UnbilledJobsCustomReportParameters {
    licensePlate?: string;
    fleetNumber?: string;
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface VehiclesCurrentStatusCustomReportParameters {
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
    treadDepth?: number;
}

export interface VehiclesDueForInspectionCustomReportParameters {
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

export interface JobVerificationCustomReportParameters {
    invoiceNumber?: string;
    jobNumber?: string;
}

export interface OdometerListCustomReportParameters {
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}
